import type { UserAssetName } from "app/UtilitiesAndConstants/types/userAssetName";
import type { FC } from "react";
import { translate } from "app/filters/i18nFilter";
import { Textfield } from "@similarweb/ui-components";
import {
    BodyContainer,
    TextFieldContainer,
    TextFieldTitle,
    SharingDisclaimer,
} from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/Styled";
import { DotsLoader } from "@similarweb/ui-components";
import { getHasSegmentShareClaim } from "app/services/segments/SegmentsUtils";

interface BodyProps {
    onSegmentNameChange: (name: string) => void;
    segmentName: UserAssetName;
    isLoading: boolean;
}

export const Body: FC<BodyProps> = (props) => {
    const { onSegmentNameChange, segmentName, isLoading } = props;
    const { assetName, isValidName, errorMessage } = segmentName;
    const onChange = (name: string) => {
        onSegmentNameChange(name);
    };
    const sharingDisclaimerKey = getHasSegmentShareClaim()
        ? "segment.wizard.new.create.modal.shared.disclaimer.private"
        : "segment.wizard.new.create.modal.shared.disclaimer.public";
    return (
        <BodyContainer>
            <TextFieldTitle>{translate("segments.popup.wizard.body.name")}</TextFieldTitle>
            <TextFieldContainer>
                <Textfield
                    error={!isValidName}
                    errorMessage={errorMessage}
                    onChange={onChange}
                    placeholder={translate("segments.popup.wizard.body.name.placeholder")}
                    defaultValue={assetName}
                    loadingComponent={<DotsLoader />}
                    isLoading={isLoading}
                    disabled={isLoading}
                />
            </TextFieldContainer>
            <SharingDisclaimer>{translate(sharingDisclaimerKey)}</SharingDisclaimer>
        </BodyContainer>
    );
};
